@import "@/styles/variables";

.selectors {
	margin-bottom: 1rem;
	margin-top: 1rem;
	display: flex;
	align-items: flex-end;
	gap: 10px;

	.customSelect {
		flex: 1;
	}

	.buttonSearch {
		flex-shrink: 0;
	}
}

.description {
	font-size: 0.9em;
	margin-bottom: 1rem;
}

.orderCodes {
	font-weight: bold;
	color: $primary-color;
}

.tableContainer {
	width: 100%;
	overflow-x: auto;
	margin-bottom: 1rem;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	border-radius: 5px;
}

.table {
	width: 100%;
	border-collapse: collapse;
}

.table th,
.table td {
	border: 1px solid $gray-200;
	text-align: left;
	font-size: 0.85em;
}

.table th {
	background-color: $gray-100;
	font-weight: bold;
}

.minimalColumn {
	text-align: center;
	background-color: #fff;
	font-size: 0.9em;
	padding: 0.75rem;
	border: 1px solid $gray-200;

	&.center {
		text-align: center;
	}

	&.right {
		text-align: right;
	}
}

.summaryRow {
	background-color: #fff;
}

.productCell {
	text-align: left;
	font-weight: 600;
	white-space: nowrap;
}

.productToggleButton {
	display: flex;
	align-items: center;
	width: 100%;
	padding: 0;
	border: none;
	background: transparent;
	color: inherit;
	font: inherit;
	text-align: left;
	cursor: pointer;
}

.collapseToggleButton {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	margin-right: 0.5rem;
	padding: 0;
	border: none;
	background: transparent;
	color: $gray-700;
	cursor: pointer;
}

.detailRow {
	background-color: $gray-100;
}

.emptyStateRow {
	background: linear-gradient(90deg, #fffaf3 0%, #fff 100%);
}

.emptyStateCell {
	text-align: center;
	padding: 1rem;
	font-size: 0.9em;
	font-weight: 600;
	color: #9a6700;
	letter-spacing: 0.01em;
}

.detailLabelCell {
	text-align: left;
	padding-left: 2rem;
	font-size: 0.85em;
	color: $gray-700;
}

@media print {
	.hideWhenPrinting {
		display: none;
	}

	body * {
		visibility: hidden;
	}
	.printableModal,
	.printableModal * {
		visibility: visible;
	}
	.printableModal {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
	}
}
